// src/Dashboard/pages/user/ArbitrageJudo/utils/arbitrageJudoUtils.js

export const normalizeText = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const filterArbitrageSections = (
  sections = [],
  { search = "", category = "Tous" } = {}
) => {
  const q = normalizeText(search);

  return sections.filter((section) => {
    const matchCategory = category === "Tous" || section.category === category;

    const haystack = normalizeText(
      [
        section.title,
        section.kicker,
        section.category,
        section.summary,
        ...(section.items || []).flatMap((item) => [
          item.title,
          ...(item.paragraphs || []),
        ]),
      ].join(" ")
    );

    const matchSearch = !q || haystack.includes(q);

    return matchCategory && matchSearch;
  });
};

export const shuffleArray = (array = []) => {
  const copy = [...array];

  for (let index = copy.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [copy[index], copy[randomIndex]] = [copy[randomIndex], copy[index]];
  }

  return copy;
};